<template>
	<base-editor-block :identifier="identifier" type="text" contentAttr="content">
		<template v-slot:default="{ content }">
			<div v-if="content && content!=='is_inactive'" v-html="$sanitize(content)" class="text-block"></div>
			<v-skeleton-loader v-if="!content && content!=='is_inactive'" type="paragraph" />
		</template>
	</base-editor-block>
</template>

<script>
import BaseEditorBlock from '../BaseEditorBlock/App';
import SanitizeMixin from '../../../mixins/buyout/sanitize';

export default {
	name: 'TextBlock',
	mixins: [SanitizeMixin],
	props: {
		identifier: {
			type: String,
			require: true
		}
	},
	components: { BaseEditorBlock }
}
</script>
